import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import {LTR} from "../../config/constants"

export const Container = styled("div")`
    display: flex;
    justify-content: flex-end;
    height: 2.75rem;
    border-radius: ${({theme}) => theme.uxfabric.shape.global.button.large.borderRadius};

    @media (min-width: ${breakpoints.values.md}px) {
        height: 2.25rem;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.button.medium.borderRadius};
    }

    && a {
        white-space: nowrap;
        padding: 0.4375rem 1rem;
        color: ${({theme}) => theme.uxfabric.components.button.outlined.secondary.enabled.contrastTextColor};
        background: ${({theme}) => theme.uxfabric.components.button.outlined.secondary.enabled.backgroundColor};
        border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.button.outlined.secondary.enabled.borderColor};
        border-radius: inherit;
        min-width: 9.375rem;
        font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
        font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight} !important;
        font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize} !important;
        letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px !important;
        line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight} !important;
        text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform} !important;
    }
`

interface ImageProps {
    alignment: string
}

export const Image = styled("img")<ImageProps>`
    transform: ${({alignment}) => (alignment === LTR ? "rotate(-90deg)" : "rotate(90deg)")};
    margin-left: 1rem;
`

export const ButtonText = styled("span")`
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
    text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
`
